
export const initialState = {
    authorized: !!localStorage.getItem('auth_access_token'),
    user: null,
}

export function builderCallback(builder) {
    builder
        .addCase('auth_clean', (state) => {
            localStorage.removeItem('auth_access_token')
            localStorage.removeItem('auth_refresh_token')
            localStorage.removeItem('auth_refresh_url')
            
            return {
                authorized: false,
                user: null,
            }
        })

        .addCase('auth_authenticated', (state, action) => {
            // Запомним информацию о токенах аутентификации и как их обновлять
            localStorage.setItem('auth_access_token', action.data.access_token)
            localStorage.setItem('auth_refresh_token', action.data.refresh_token)
            localStorage.setItem('auth_refresh_url', action.data.refresh_url)

            // Пользователь аутентифицирован
            state.authorized = true
            state.user = undefined

            return state
        })

        .addCase('auth_data', (state, action) => {
            state.user = action.data
            return state
        })

        .addDefaultCase((state, action) => {
            return state
        })
}
